import AutoSuggest from '@common/AutoSuggest';
import { appConfig } from '@common/config';
import { useSetSearchParams } from '@hook/useSetSearchParams';
import { useEffect, useRef, useState, type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';

export const SearchForm = ({ props, children }: { props: ISearchFormProp; children: ReactNode }) => {
    const { t } = useTranslation();
    const [searchParams] = useSearchParams();
    const setParams = useSetSearchParams();
    const elCon = useRef<HTMLDivElement>(null);
    const [query, querySet] = useState({ value: props.value, isListClick: false });

    useEffect(() => {
        if (!elCon.current) return;
        if (!searchParams) return;
        if (!autoSuggest) return;

        const value = searchParams.get(props.watch);
        autoSuggest.value(value ?? '');

        if (!autoSuggest.inputEl) {
            autoSuggest.init({
                apiUrl: `${appConfig.apiDomain}/${appConfig.service}${props.apiPath}`,
                selector: '#autoSuggest',
                cookieName: `${appConfig.service}GameInfoAutoSuggest-itemprice`,
                keywordParamName: 'searchKeyword',
                size: 10,
                useDelbtn: true,
                locale: appConfig.locale,
                submitCallback: (_q: string, _isListClick) => {
                    props.submitCallback(_q);
                    querySet({ value: _q, isListClick: _isListClick });
                },
            });
        }
    }, [props, searchParams]);

    useEffect(() => {
        if (query.value === null) return;
        setParams({
            [props.watch]: query.value ?? '',
            exactsearch: query.isListClick.toString(),
            ...props.resetObj,
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [query]);

    return (
        <div className="gameinfo-search-wrapper ncui-searchform" ref={elCon}>
            {children}
            <form
                data-name="suggest_form"
                id="autoSuggest"
                className="gameinfo-search"
                method="get"
                action=""
                onSubmit={(e) => e.preventDefault()}
                role="search"
            >
                <input type="search" autoComplete="off" data-name="suggest_input" placeholder={props.placeholderStr} />
                <button value="X" title="Delete" data-name="suggest_delete" />
                <button value="GO" title="Search" data-name="suggest_submit" />
                <div data-name="suggest_wrap">
                    <div data-name="suggest_list">
                        <div data-name="suggest_scroll">
                            <ul></ul>
                        </div>
                    </div>
                    <div data-name="suggest_recent">
                        <div data-name="suggest_recent_scroll">
                            <ul></ul>
                            <div data-name="suggest_recent-none" style={{ display: 'none' }}>
                                {t('common.norecentsearchhistory')}
                            </div>
                        </div>
                        <div data-name="suggest_recent-del">
                            <button type="button">{t('common.deleteallrecent')}</button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    );
};

export interface ISearchFormProp {
    placeholderStr: string;
    submitCallback: (_q: string) => void;
    watch: string;
    resetObj: Record<string, string>;
    value: string | null;
    apiPath: string;
}
const autoSuggest = new AutoSuggest();
